"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = returnDsAssetArrayWithExemptions;

var _getCaseExemptions = _interopRequireDefault(require("./getCaseExemptions"));

var _mapAssetObjectsToClassModel = _interopRequireDefault(require("./mapAssetObjectsToClassModel"));

var _mapCaseExemptionsToAssetObject = _interopRequireDefault(require("./mapCaseExemptionsToAssetObject"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function returnDsAssetArrayWithExemptions(caseObj, assets) {
  var jurisdiction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'FEDERAL';
  var transformedAssets = (0, _mapAssetObjectsToClassModel["default"])(assets);
  var assetToExemptionMap = (0, _getCaseExemptions["default"])(caseObj, transformedAssets, jurisdiction);
  var updatedAssetArray = (0, _mapCaseExemptionsToAssetObject["default"])(assetToExemptionMap, assets);
  return updatedAssetArray;
}